import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
import { useBreakpoint } from '@design-system/theme';
export const BlockHeaderControls = ({ controls, forceAlign }) => {
    const breakpoint = useBreakpoint();
    const align = forceAlign || (['s', 'm'].includes(breakpoint) ? 'left' : 'right');
    const alignLeft = align === 'left';
    return (_jsx(Box, { justifyContent: alignLeft ? 'flex-start' : 'flex-end', children: controls.map((control, index) => {
            const shouldForceAlignLeft = alignLeft && index + 1 <= controls.length;
            return (_jsx(Box, { minWidth: index > 0 ? 0 : undefined, ml: shouldForceAlignLeft ? 0 : 3, mr: shouldForceAlignLeft ? 3 : 0, children: control }, index));
        }) }));
};
//# sourceMappingURL=index.js.map